import { FC } from "react";
import { BaseProps } from "./text";
import GText from "./GText";
import { css } from "@emotion/react";

interface Props {
  text?: string;
}

const GTextHoverVarFont: FC<Props & BaseProps> = (props) => {
  const styles = css`
    background: ${props.background};
    transition: width 2s;

    & .letter {
      display: inline-block;
      color: ${props.color};
      transform: scale(1);
      border-radius: 50%;
      pointer-events: none; /* This prevents the element from capturing mouse events */
      transition: all ${props.duration}s;
      white-space: break-spaces;
    }
  `;

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, i) => (
      <span id="g-hover-shine-text" className="letter" key={i}>
        {l}
      </span>
    ));
  };

  const mouseMoveHandler = (event: React.MouseEvent) => {
    const mouseX = event.clientX;
    const mouseY = event.clientY;

    const letterElements = document.querySelectorAll("#g-hover-shine-text");

    letterElements.forEach((element) => {
      const elementRect = element.getBoundingClientRect();
      const elementX = elementRect.left + elementRect.width / 2;
      const elementY = elementRect.top + elementRect.height / 2;

      const distance = Math.sqrt(
        (elementX - mouseX) ** 2 + (elementY - mouseY) ** 2
      );

      const letterElement = element as HTMLElement;

      const distanceCompareValue = props.fontSize ? props.fontSize / 2 + 2 : 15;

      const updateElementProperties = (
        scale: string,
        brightness: string,
        fontWeight: string
      ) => {
        letterElement.style.transform = `scale(${scale})`;
        letterElement.style.filter = brightness;
        letterElement.style.fontWeight = fontWeight;
      };

      if (distance <= distanceCompareValue) {
        /* closest */
        updateElementProperties("1.1", "brightness(1.8)", "600");
      } else if (distance <= distanceCompareValue + 5) {
        /* normal distance (closest + 5px) */
        updateElementProperties("1.08", "brightness(1.5)", "500");
      } else if (distance <= distanceCompareValue + 15) {
        /* medium distance (closest + 15px) */
        updateElementProperties("1.03", "brightness(1.3)", "500");
      } else if (distance <= distanceCompareValue + 30) {
        /* vast distance (closest + 30px) */
        updateElementProperties("1.01", "brightness(1.2)", "400");
      } else {
        /* outside  */
        updateElementProperties("1", "brightness(1)", "inherit");
      }
    });
  };

  const mouseLeaveHandler = () => {
    const letterElements = document.querySelectorAll("#g-hover-shine-text");

    letterElements.forEach((element) => {
      const letterElement = element as HTMLElement;

      letterElement.style.transform = "scale(1)";
      letterElement.style.filter = "brightness(1)";
      letterElement.style.fontWeight = "inherit";
    });
  };

  return (
    <GText {...props}>
      <div
        css={styles}
        className="g-text-shine"
        onMouseMove={mouseMoveHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        {splitTextIntoSpan()}
      </div>
    </GText>
  );
};

GTextHoverVarFont.defaultProps = {
  text: "Grooody",
  color: "#a3a3a3",
  fontSize: 50,
  fontWeight: "bold",
  background: "#000",
  duration: 0.2,
};

export default GTextHoverVarFont;

// We need to add the below in framer
/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
     background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    duration: {
        title: "Duration",
        type: ControlType.Number,
        defaultValue: 0.4,
        description: "Animation duration",
    },
})
*/
